import React, { useCallback } from 'react';
import { useField } from 'formik';

import CheckboxGroup from '..';

const CheckboxGroupMemo = React.memo(CheckboxGroup);

const CheckboxGroupCFormik = (props) => {
	const { name } = props;

	const [field, meta, helpers] = useField(name);
	const { value } = field;
	const { setValue, setTouched } = helpers;

	const handleChange = useCallback(
		(e) => {
			const newValue = value.filter((v) => v !== e.target.value);

			if (e.target.checked) {
				newValue.push(e.target.value);
			}

			setValue(newValue);
			setTimeout(() => {
				setTouched(true); // Validation issue
			}, 0);
		},
		[setValue, setTouched, value],
	);

	if (!name) return 'For CheckboxGroup connected to Formik name is required!';

	return (
		<CheckboxGroupMemo
			value={value}
			onChange={handleChange}
			error={(meta.touched || meta.initialTouched) && meta.error}
			{...props}
		/>
	);
};

CheckboxGroupCFormik.propTypes = {
	...CheckboxGroup.propTypes,
};

export default CheckboxGroupCFormik;
